/**
 * Extracts a Google Reservas unit code from free text (e.g. pasted email body).
 */
export const extractGoogleReserveUnitCode = (raw: string): string => {
  const text = (raw ?? "").trim();

  if (!text) {
    return "";
  }

  const labeledPatterns = [
    /c[oó]digo(?:\s+da\s+unidade)?\s*[:-]\s*([A-Za-z0-9._-]{4,128})/i,
    /unit\s*code\s*[:-]\s*([A-Za-z0-9._-]{4,128})/i,
    /c[oó]digo(?:\s+de\s+la\s+unidad)?\s*[:-]\s*([A-Za-z0-9._-]{4,128})/i,
    /merchant[_-]?id\s*[:-]\s*([A-Za-z0-9._-]{4,128})/i,
  ];

  for (const pattern of labeledPatterns) {
    const match = text.match(pattern);
    if (match?.[1]) {
      return match[1].trim();
    }
  }

  const merchantMatch = text.match(/\b(merchant-[A-Za-z0-9._-]{2,120})\b/i);
  if (merchantMatch?.[1]) {
    return merchantMatch[1].trim();
  }

  if (/^[A-Za-z0-9._-]{4,128}$/.test(text)) {
    return text;
  }

  const firstLine = text.split(/\r?\n/).map((line) => line.trim()).find(Boolean) ?? "";
  if (/^[A-Za-z0-9._-]{4,128}$/.test(firstLine)) {
    return firstLine;
  }

  const token = text
    .split(/\s+/)
    .find((part) => /^[A-Za-z0-9._-]{6,128}$/.test(part));

  return token ?? firstLine;
};

export const formatCooldownCountdown = (availableAgainAt: string | null | undefined): string | null => {
  if (!availableAgainAt) {
    return null;
  }

  const target = new Date(availableAgainAt).getTime();
  if (Number.isNaN(target)) {
    return null;
  }

  const remainingMs = target - Date.now();
  if (remainingMs <= 0) {
    return null;
  }

  const totalMinutes = Math.ceil(remainingMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours <= 0) {
    return `${minutes}m`;
  }

  return `${hours}h ${String(minutes).padStart(2, "0")}m`;
};
